/**
 * A small sunburst whose lit rays count something real (monthly posts).
 * `foundation` lights only the centre: the base every plan builds on.
 */
export function RayMeter({
  lit,
  total = 12,
  foundation = false,
  tone = "light",
  className = "",
}: {
  lit: number;
  total?: number;
  foundation?: boolean;
  tone?: "light" | "navy";
  className?: string;
}) {
  const navy = tone === "navy";
  const idle = navy ? "rgb(255 255 255 / 0.16)" : "rgb(26 60 94 / 0.12)";
  return (
    <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
      {Array.from({ length: total }, (_, i) => {
        const angle = -90 + (360 / total) * i;
        const long = i % 2 === 0;
        const on = !foundation && i < lit;
        return (
          <line
            key={i}
            x1={60}
            y1={60 - 25}
            x2={60}
            y2={60 - (long ? 55 : 47)}
            transform={`rotate(${angle + 90} 60 60)`}
            stroke={on ? "#72b5b1" : idle}
            strokeWidth={6.5}
            strokeLinecap="round"
          />
        );
      })}
      <circle
        cx={60}
        cy={60}
        r={15}
        fill={foundation ? "#72b5b1" : navy ? "#1a3c5e" : "#ffffff"}
        stroke={foundation || lit > 0 ? "#72b5b1" : idle}
        strokeWidth={2.5}
      />
    </svg>
  );
}
